import { useControllableState } from "../../utils/hooks/useControllableState";
import { Props, Wrapper } from "./Slider.Parts";
import { ContinuousSlider } from "./continuous/ContinuousSlider";
import { SliderDiscrete } from "./discrete/SliderDiscrete";

export const Slider = ({
  type = "continuous",
  labels,
  fullWidth = true,
  step = 1,
  max = 100,
  min = 0,
  value,
  defaultValue,
  onChange,
  onChangeCommitted,
  onDiscreteKeyDown,
  ...props
}: Props) => {
  const [internalValue, setValue] = useControllableState(
    value,
    defaultValue,
    (val: number | number[], ev: Event) => onChange && onChange(val, ev),
  );

  const slider = (
    <ContinuousSlider
      {...props}
      step={step}
      value={internalValue}
      onChange={(ev, val) => setValue(val, ev)}
      onChangeCommitted={
        onChangeCommitted
          ? (event, value) =>
              onChangeCommitted(value, event as unknown as Event)
          : undefined
      }
      max={max}
      min={min}
    />
  );

  if (type === "discrete") {
    return (
      <Wrapper $fullWidth={fullWidth}>
        <SliderDiscrete
          step={step}
          labels={labels}
          value={
            Array.isArray(internalValue) ? internalValue : [internalValue ?? 0]
          }
          setValue={setValue}
          max={max}
          min={min}
          onKeyDown={onDiscreteKeyDown}
        />
        {type === "discrete" && slider}
      </Wrapper>
    );
  }

  return <Wrapper $fullWidth={fullWidth}>{slider}</Wrapper>;
};
